/* eslint-disable import/no-duplicates */
import Vue from 'vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

// ------ same icon different styles ------//
// The Pro subscription was retired, so the former 'fal' (light) styling is now served by
// the free 'far' (regular/outline) set where an outline version exists, and by 'fas' (solid)
// where it does not. See the mapping note at the bottom of this file.
import { faBookmark as fasBookmark } from '@fortawesome/free-solid-svg-icons';
import { faBookmark as farBookmark } from '@fortawesome/free-regular-svg-icons';

// ------ FREE - Solid icons (previously Pro solid) ------//
// PREFIX : 'fas'
import { faPlane,
  faCarSide,
  faBars,
  faTriangleExclamation,
  faSpinner,
  faXmark,
  faHourglass,
  faArrowRightFromBracket,
} from '@fortawesome/free-solid-svg-icons';

// ------ FREE - Regular icons (previously Pro light) ------//
// PREFIX : 'far'
// Example :  <font-awesome-icon :icon="['far', 'minus-square']" />
import {
  faPlusSquare,
  faMinusSquare,
  faWindowClose,
  faTimesCircle,
  faEdit,
} from '@fortawesome/free-regular-svg-icons';

// ------ FREE - Solid icons (previously Pro light, no outline version available) ------//
// PREFIX : 'fas'
import {
  faGlobe,
  faMapMarkerAlt,
  faShoppingBag,
  faFileCircleXmark,
  faFileArrowDown,
  faDownload,
  faArrowUpRightFromSquare,
  faImages,
} from '@fortawesome/free-solid-svg-icons';

// ------ FREE - Solid icons  ------//
// PREFIX : 'fas'
// Example :  <font-awesome-icon :icon="['fas', 'minus-square']" />
import {
  faCaretRight,
  faCaretLeft,
  faCaretUp,
  faCaretDown,
  faEnvelope,
  faClock,
  faPhone,
  faBriefcase,
  faTimes,
  faUndo,
  faUndoAlt,
  faPlus,
  faMinus,
  faUser,
  faBed,
  faBath,
  faMoon,
  faExclamationCircle,
  faCalendarCheck,
  faPencilAlt,
  faTicketAlt,
  faFile,
  faPassport,
  faShoppingCart,
  faTrashAlt,
  faArrowRight,
  faArrowLeft,
  faMap,
  faSlidersH,
  faCheckCircle,
  faCircle,
  faEllipsisV,
  faTruck,
  faCommentDots,
  faShareAlt,
  faEye,
  faEyeSlash,
  faInfoCircle,
  faExpand,
  faSearch,
  faTag,
  faTags,
  faMousePointer,
  faUserFriends,
  faQuestionCircle,
  faReply,
  faStar,
  faTaxi,
  faFerry,
  faHourglassStart,
  faBuildingColumns,
  faCreditCard,
  faChevronCircleRight,
  faLocationDot,
  faChevronLeft,
  faChevronDown,
  faChevronRight,
  faMagnifyingGlass,
  faCircleCheck,
  faCheck as fasCheck,
} from '@fortawesome/free-solid-svg-icons';

// ------ FREE - Brand SVG icons  ------//
// PREFIX : 'fab'
// Example :  <font-awesome-icon :icon="['fab', 'facebook']" />
import {
  faTwitter,
  faInstagram,
  faYoutube,
  faSpotify,
  faWhatsapp,
  faFacebook,
  faFacebookF,
  faFacebookMessenger,
  faFacebookSquare,
  faGoogle,
  faApple,

} from '@fortawesome/free-brands-svg-icons';

library.add(
  faCaretRight,
  faCaretLeft,
  faCaretUp,
  faCaretDown,
  faEnvelope,
  faClock,
  faPhone,
  faBriefcase,
  faTimes,
  faMapMarkerAlt,
  faUndo,
  faUndoAlt,
  faPlus,
  faMinus,
  faUser,
  faBed,
  faBath,
  faMoon,
  faExclamationCircle,
  faCalendarCheck,
  faPencilAlt,
  faTicketAlt,
  faFile,
  faStar,
  faPassport,
  faShoppingCart,
  faTrashAlt,
  faArrowRight,
  faArrowLeft,
  faMap,
  faSlidersH,
  faCheckCircle,
  faCircle,
  faTruck,
  faEllipsisV,
  faCommentDots,
  faShareAlt,
  faEye,
  faEyeSlash,
  faInfoCircle,
  faExpand,
  faSearch,
  faPlusSquare,
  faMinusSquare,
  faGlobe,
  faTag,
  faTags,
  faWindowClose,
  faMousePointer,
  faUserFriends,
  faQuestionCircle,
  faReply,
  faTimesCircle,
  faEdit,
  faShoppingBag,
  faPlane,
  faTaxi,
  faFerry,
  fasBookmark,
  farBookmark,
  faArrowRightFromBracket,
  faBars,
  faTriangleExclamation,
  faImages,
  faXmark,
  faHourglassStart,
  faCarSide,
  faBuildingColumns,
  faCreditCard,
  faSpinner,
  faChevronCircleRight,
  faLocationDot,
  faHourglass,
  faFileCircleXmark,
  faChevronLeft,
  faChevronDown,
  faChevronRight,
  faMagnifyingGlass,
  faFileArrowDown,
  faDownload,
  faArrowUpRightFromSquare,
  faCircleCheck,
  fasCheck,
);

// BRANDS
library.add(
  faTwitter,
  faInstagram,
  faYoutube,
  faSpotify,
  faWhatsapp,
  faFacebook,
  faFacebookF,
  faFacebookMessenger,
  faFacebookSquare,
  faGoogle,
  faApple,
);

Vue.component('font-awesome-icon', FontAwesomeIcon);

// ------------------NOTES-------------------------//

// Style		    font-face weight
//---------------------------------------
// Solid	        900
// Regular	        400
// Light	        300
// Duotone	        900
// Brands	        400

// AVAILABLE PACKAGES
// We are on the FREE plan — only these three icon packages are available, all from the
// public npm registry. The Pro packages (pro-light, pro-solid, pro-regular, pro-thin,
// pro-duotone, sharp-*) need a paid subscription and a token for npm.fontawesome.com;
// that subscription was allowed to expire, so they must not be reintroduced.
// npm i --save @fortawesome/free-solid-svg-icons     (prefix 'fas')
// npm i --save @fortawesome/free-regular-svg-icons   (prefix 'far' — outline)
// npm i --save @fortawesome/free-brands-svg-icons    (prefix 'fab')
//
// MIGRATION NOTE (Pro -> Free)
// The old 'fal' (Pro light) prefix no longer exists. Former 'fal' icons were remapped to:
//   'far' (outline, closest match) : edit, window-close, plus-square, minus-square, bookmark
//   'fas' (solid, no outline available) : shopping-bag
// And one Pro-only icon was substituted:
//   'fal' folder-image -> 'fas' images
// Two other Pro-only icons (grid, car-bus) were registered but never used, so were dropped.

// ---- EXAMPLE BELOW OF IMPORTING SAME ICON BUT IN DIFFERENT STYLES ---- //
// import { faCoffee as fasCoffee } from '@fortawesome/pro-solid-svg-icons'
// import { faCoffee as farCoffee } from '@fortawesome/pro-regular-svg-icons'
// import { faCoffee as falCoffee } from '@fortawesome/pro-light-svg-icons'
// import { faCoffee as fadCoffee } from '@fortawesome/pro-duotone-svg-icons'
// import { faCoffee as fassCoffee } from '@fortawesome/sharp-solid-svg-icons'
// library.add(fasCoffee, farCoffee, falCoffee, fadCoffee, fassCoffee)

// ---- EXAMPLE HOW TO ADD DIFFERENT STYLES IN THE TEMPLATE ----- //
// <!-- Add Icons using String format -->
// <font-awesome-icon icon="fa-solid fa-coffee" />
// <font-awesome-icon icon="fa-regular fa-coffee" />
// <font-awesome-icon icon="fa-light fa-coffee" />
// <font-awesome-icon icon="fa-duotone fa-coffee" />
// <font-awesome-icon icon="fa-sharp fa-solid fa-coffee" />

// <!-- Add Icons using Array format -->
// <font-awesome-icon :icon="['fas', 'coffee']" />
// <font-awesome-icon :icon="['far', 'coffee']" />
// <font-awesome-icon :icon="['fal', 'coffee']" />
// <font-awesome-icon :icon="['fat', 'coffee']" />
// <font-awesome-icon :icon="['fad', 'coffee']" />
// <font-awesome-icon :icon="['fass', 'coffee']" />

// ------ PRO - Duotone icons  ------//
// PREFIX : 'fad'
// Example :  <font-awesome-icon :icon="['fad', 'minus-square']" />
// import { xxx } from '@fortawesome/pro-duotone-svg-icons';
// library.add(xxx);

// ------ PRO - Regular icons  ------//
// PREFIX : 'far'
// Example :  <font-awesome-icon :icon="['far', 'minus-square']" />
